import React from 'react';

/**
 * Live chart image served by FRED for a given series, with a link-out fallback
 * if the image fails to load.
 */
const FredChart = ({ series, title }) => {
  if (!series) {
    return (
      <div
        className="bg-gray-50 rounded-lg flex items-center justify-center text-center text-gray-500 p-8"
        style={{ minHeight: '300px' }}
      >
        <div>
          <div className="text-4xl mb-2">📊</div>
          <p>Chart not available</p>
          <p className="text-sm">for this indicator</p>
        </div>
      </div>
    );
  }

  const seriesUrl = `https://fred.stlouisfed.org/series/${series}`;

  // Window ends today so the chart always runs through the current date.
  const today = new Date();
  const endDate = today.toISOString().slice(0, 10);
  const startDate = `${today.getFullYear() - 10}-01-01`;

  const chartUrl =
    `https://fred.stlouisfed.org/graph/fredgraph.png?id=${series}` +
    `&width=700&height=400&cosd=${startDate}&coed=${endDate}` +
    `&fq=Daily&fam=avg&fgst=lin&transformation=lin` +
    `&line_color=%234572a7&bgcolor=%23ffffff&graph_bgcolor=%23ffffff`;

  return (
    <div className="bg-gray-50 rounded-lg overflow-hidden border">
      <div className="w-full flex items-center justify-center bg-white p-4">
        <div className="w-full">
          <img
            src={chartUrl}
            alt={`FRED chart: ${title || series}`}
            className="w-full h-auto object-contain rounded"
            style={{ minHeight: '300px', backgroundColor: '#ffffff' }}
            onError={(event) => {
              event.currentTarget.style.display = 'none';
              const fallback = event.currentTarget.parentElement.querySelector('.fallback-chart');
              if (fallback) fallback.style.display = 'flex';
            }}
          />

          <div
            className="fallback-chart hidden items-center justify-center text-center text-gray-500 p-8"
            style={{ minHeight: '300px' }}
          >
            <div>
              <div className="text-4xl mb-2">📊</div>
              <p className="font-medium">{title || series}</p>
              <p className="text-sm mt-2">
                <a href={seriesUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
                  View live chart on FRED →
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="p-3 text-xs text-gray-500 text-center bg-gray-100">
        Live data from:{' '}
        <a href={seriesUrl} target="_blank" rel="noopener noreferrer" className="text-blue-600 hover:underline">
          FRED - Federal Reserve Economic Data
        </a>
      </div>
    </div>
  );
};

export default FredChart;
